import React, { useState, useLayoutEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    useLayoutEffect(() => {
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 100);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error and success message when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
        if (successMessage) {
            setSuccessMessage('');
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Email validation
        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
        setErrors({});
        setSuccessMessage('');

        // try {
        //     // Replace this with your actual API call
        //     const response = await fetch('/api/forgot-password', {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         },
        //         body: JSON.stringify({
        //             email: formData.email
        //         })
        //     });

        //     const data = await response.json();

        //     if (response.ok) {
        //         // Show success message
        //         setSuccessMessage(
        //             data.message || 
        //             'Password reset link has been sent to your email address. Please check your inbox.'
        //         );
                
        //         // Clear form
        //         setFormData({ email: '' });
                
        //         // Optional: Redirect to login after a delay
        //         // setTimeout(() => {
        //         //     navigate('/login');
        //         // }, 3000);
        //     } else {
        //         setErrors({
        //             submit: data.message || 'Failed to send reset link. Please try again.'
        //         });
        //     }
        // } catch (error) {
        //     console.error('Forgot password error:', error);
        //     setErrors({
        //         submit: 'An error occurred. Please try again later.'
        //     });
        // } finally {
        //     setIsSubmitting(false);
        // }
    };

    return (
        <div className="wrapper position-relative">
            <Header />

            {/* Background Masks */}
            <div className="wrapper position-relative overflow-x-clip">
                <div className="mask mask-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                        <circle cx="400" cy="400" r="325" stroke="url(#a6)" strokeWidth="150" />
                        <defs>
                            <linearGradient id="a6" x1="176" x2="569" y1="70.5" y2="674">
                                <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                                <stop offset="1" stopColor="#fff" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div className="mask mask-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                        <circle cx="400" cy="400" r="325" stroke="url(#e7)" strokeWidth="150" />
                        <defs>
                            <linearGradient id="e7" x1="176" x2="569" y1="70.5" y2="674">
                                <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                                <stop offset="1" stopColor="#fff" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
            </div>

            {/* Page Title */}
            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title">
                            <span className="split-text effect-right">Forgot Password</span>
                        </h1>
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Home</span>
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Forgot Password</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="main-content">
                <section className="section-contact p-contact tf-spacing-2">
                    <div className="tf-container">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-6">
                                <div className="section-contact-inner flex justify-content-between flex-wrap login-form">
                                    <form 
                                        id="forgotpasswordform" 
                                        className="form-contact-us style-bg-dark-2 px-md-15" 
                                        onSubmit={handleSubmit}
                                    >
                                        {/* Success Message */}
                                        {successMessage && (
                                            <div className="alert alert-success mb-37" role="alert">
                                                <i className="fa fa-check-circle me-2"></i>
                                                {successMessage}
                                            </div>
                                        )}

                                        {/* Email Field */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-email"></i>
                                                    <input 
                                                        type="email" 
                                                        name="email" 
                                                        id="email" 
                                                        placeholder="Email Address"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        className={errors.email ? 'error' : ''}
                                                        disabled={isSubmitting}
                                                    />
                                                    {errors.email && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.email}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Submit Error */}
                                        {errors.submit && (
                                            <div className="alert alert-danger mb-37" role="alert">
                                                <i className="fa fa-exclamation-circle me-2"></i>
                                                {errors.submit}
                                            </div>
                                        )}

                                        {/* Links */}
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="mb-37">
                                                    <Link to="/login">Login</Link>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="mb-37 create-account">
                                                    <Link to="/register">Create an Account</Link>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Submit Button */}
                                        <button 
                                            type="submit"
                                            className="tf-btn style-bg-primary w-full justify-content-center"
                                            disabled={isSubmitting}
                                        >
                                            <span>{isSubmitting ? 'Sending...' : 'Continue'}</span>
                                            <i className="icon-arrow-right"></i>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    );
};

export default ForgotPassword;